import React from "react";
import "./Customer.css";
import { Text, HStack, Box, Image } from "@chakra-ui/react";

const Customer = () => {
  return (
    <div id="customer">
      <Box data-aos="fade-up" data-aos-duration="3000">
        <Text className="cus-title1">Customer Review</Text>
        <Text className="cus-title2">Customer Review</Text>
      </Box>
      <Box className="marquee2">
        <HStack
         
          className="cus-cards track2"
          gap={20}
        >
          <Box className="cus-card">
            <Text className="quote">“</Text>
            <Text className="cus-des">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              dignissim nisi nec nisi dapibus, non volutpat leo molestie.
            </Text>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              my={6}
              alignItems={"center"}
            >
              <Text className="cus-deg hover-text">
                Cheryl Sandberg <br /> CEO & Director ( ISTEM LLC)
              </Text>
              <Image src="/cus1-mask.png" />
            </Box>
          </Box>
          <Box className="cus-card">
            <Text className="quote">“</Text>
            <Text className="cus-des">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              dignissim nisi nec nisi dapibus, non volutpat leo molestie.
            </Text>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              my={6}
              alignItems={"center"}
            >
              <Text className="cus-deg">
                Cheryl Sandberg <br /> CEO & Director ( ISTEM LLC)
              </Text>
              <Image src="/cus1-mask.png" />
            </Box>
          </Box>
          <Box className="cus-card">
            <Text className="quote">“</Text>
            <Text className="cus-des">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              dignissim nisi nec nisi dapibus, non volutpat leo molestie.
            </Text>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              my={6}
              alignItems={"center"}
            >
              <Text className="cus-deg">
                Cheryl Sandberg <br /> CEO & Director ( ISTEM LLC)
              </Text>
              <Image src="/cus1-mask.png" />
            </Box>
          </Box>
          <Box className="cus-card">
            <Text className="quote">“</Text>
            <Text className="cus-des">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              dignissim nisi nec nisi dapibus, non volutpat leo molestie.
            </Text>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              my={6}
              alignItems={"center"}
            >
              <Text className="cus-deg">
                Cheryl Sandberg <br /> CEO & Director ( ISTEM LLC)
              </Text>
              <Image src="/cus1-mask.png" />
            </Box>
          </Box>
        </HStack>
      </Box>
    </div>
  );
};

export default Customer;
